export const config = {
  apiUrl: 'https://echurchv1-api.visibilitycam.com/api'
  //apiUrl: 'http://localhost:8000/api'

};
